import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { IndividualFieldTableType } from '../Enums/IndividualFieldTableType.enum';

export class CustomFieldPage<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: name */
  name?: any;
  /** Alias: tableType */
  tableType?: IndividualFieldTableType;

  __typename?: string;
}

const fields: FieldDefinitions<CustomFieldPage> = {
  id: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  tableType: {
    alias: 'tableType',
  },
  __typename: {
    alias: '__typename',
  },
};

export const customFieldPageEntityDefinition: EntitiyDefinition<CustomFieldPage> =
  {
    local: {},
    remote: {
      queryName: 'getCustomFieldPages',
      fragmentName: 'CustomFieldPage',
      withPaginationWrapper: false,
      params: [{ name: 'tableType', type: 'IndividualFieldTableType' }],
    },
    fieldDefinitions: fields,
  };
